import { useState, useEffect } from "react";
import { Steps, Divider } from "antd";

import StartUpload from "./StartUpload";
import Feedback from "./Feedback";
import Preview from "./Preview";
import api from "../../../services/stemiService";
import { recordError } from "../../../utils/logService";
import UploadProgress from "./UploadProgress";

import {
  Messages,
  Notify,
  openNotification,
  util,
} from '@seims/shared';

const DataUpload = ({ file }) => {
  const [uploadedFile, setUploadedFile] = useState({});
  const [current, setCurrent] = useState(0);
  const [progress, setProgress] = useState(0);
  const [feedbackData, setFeedbackData] = useState({});
  const [loading, setLoading] = useState(false);
  const [recordLimit, setRecordLimit] = useState(100);

  const { Step } = Steps;

  useEffect(() => {
    getRecordLimit();
  }, []);

  const updateStatus = (status) => {
    setCurrent(status);
  };

  const trackProgress = (progress) => {
    setProgress(progress);
  };

  const handleFileSubmit = async (file) => {
    try {
      setLoading(true);
      setProgress(1);
      var msg;

      const response = await api.uploadFile(file, trackProgress);

      if (response.status === 200 || response.status === 201) {
        const { data } = response;
        setFeedbackData(data);
        setCurrent(3);
        setProgress(1);
        setLoading(false);

        return;
      }

      msg = util.parseMessage(Messages.FILEUPLOAD_FAILURE, "File");
      openNotification("File Upload", msg, Notify.ERROR);
    } catch (error) {
      if (error.response.status === 406) {
        msg = util.parseMessage(Messages.FILEUPLOAD_FAILURE_SIZE, "File");
        openNotification("File Upload Failed", msg, Notify.ERROR);
      }

      msg = util.parseMessage(Messages.FILEUPLOAD_FAILURE, "File");
      openNotification("File Upload", msg, Notify.ERROR);

      recordError(error);
      setLoading(false);
      setProgress(0);
    }
  };

  const getRecordLimit = async () => {
    try {
      const response = await api.getRecordLimit();

      if (response && response.status === 200) {
        const { data } = response;
        setRecordLimit(data.totalRecords);
      }
      else {
        setRecordLimit(100);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const title = "STEMI Olympiad Data Upload";
  const subTitle = "Select file to upload for processing";

  return (
    <div className="content">
      <h1 className="center-align">{title}</h1>
      <p className="sub-title center-align">{subTitle}</p>

      <Steps current={current}>
        <Step title="Start"></Step>
        <Step title="Preview"></Step>
        <Step title="Upload"></Step>
        <Step title="Results"></Step>
      </Steps>
      <Divider />
      <div>
        {current === 0 ? (
          <StartUpload
            setUploadedFiles={setUploadedFile}
            setProgressState={updateStatus}
          />
        ) : current === 1 ? (
          <Preview
            file={uploadedFile}
            setProgressState={updateStatus}
            onFileSubmit={handleFileSubmit}
            recordLimit={recordLimit}
          />
        ) : current === 2 ? (
          <UploadProgress
            progress={progress}
            setProgressState={updateStatus}
            loading={loading}
          />
        ) : (
          <Feedback
            setProgressState={updateStatus}
            data={feedbackData}
            file={uploadedFile}
          />
        )}
      </div>
    </div>
  );
};

export default DataUpload;
